/**
 * Milestone growth-goal thresholds (§6.4 FE-4) — pure config.
 *
 * These live in FE config (per the §6.1 contract note: milestone thresholds are
 * FE-driven, no separate backend query — the card is driven purely by
 * `totalUsers` from `adminDashboardKpis`). The view-model derivation that runs
 * over them lives in `milestones.model.ts`.
 */

/** User-count growth goals since launch (ascending). */
export const MILESTONE_THRESHOLDS: readonly number[] = [100, 500, 1000, 2500, 5000, 10000];
